const { SET_MENU_NEW_REPORT_LIST } = require("../../components/AppProvider");
const { PostApiGetNewPoint } = require("../network/padoPost");

export const requestGetNewPoint = (userinfo, cfg, phonecfg, dispatch) => {
  PostApiGetNewPoint(userinfo, cfg, phonecfg)
    .then((res) => {
      if (res.resultCode === "E000") {
        dispatch({ type: SET_MENU_NEW_REPORT_LIST, data: res.result });
      } else {
        console.log("Interface Fail");
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
